import { pick } from 'lodash/fp';
import { setDefaultValue } from 'utils';
import request from 'utils/request_ajax';
import { PATH_MODES, TYPES, routes } from 'constants/config';
import * as actions from './actionCreators';
import { toggleEditingMode } from './index';

export function add(type, position, content) {
  return (dispatch, getState) => {
    const { mode } = getState().pathBuilder;
    if (mode !== PATH_MODES.EDIT) {
      dispatch(toggleEditingMode());
    }
    if (type === TYPES.DEMONSTRATION && !content) {
      dispatch(actions.showNewDemonstrationForm(position));
    } else {
      dispatch(actions.addContent(type, position, content));
    }
  };
}

export function update(id, type, changes) {
  return dispatch => {
    /**
     * When replacing exisitng steps with new content, updateContent is going to
     * merge the new changes (which can be the new content) with the exisitng
     * step. The following block can be used to "reset" any props needed.
     */
    const isReplacingContent = changes.id && changes.id !== id;
    if (isReplacingContent) {
      changes.dueIn = null;
      changes.description = setDefaultValue(changes.description, null);
      changes.enforcedOrder = setDefaultValue(changes.enforcedOrder, false);
    }
    dispatch(actions.updateContent(id, type, changes));
  };
}

export function remove(id, type) {
  return dispatch => {
    dispatch(actions.removeContent(id, type));
  };
}

export function reorder(position, newPosition) {
  return dispatch => {
    dispatch(actions.reorderContent(position, newPosition));
  };
}

export function toggleEditing(id, type, view) {
  return dispatch => {
    dispatch(actions.toggleEditing(id, type, view));
  };
}

export function showDemonstrationBuilder(demonstration) {
  return dispatch => {
    dispatch(actions.showDemonstrationBuilder(demonstration));
  };
}

export function persist(id, type) {
  return dispatch => {
    dispatch(actions.persistContent(id, type));
  };
}

export function cancelEditing(id, type, justAdded) {
  return dispatch => {
    const identity = [id, type];
    dispatch(actions.toggleEditing(...identity));
    if (justAdded) {
      dispatch(actions.removeContent(...identity));
    }
  };
}

export function replacePlaceholder(id, type, content) {
  // TODO backend should return lessons and descriptions
  return actions.updateContent(id, type, {
    ...content,
    ...(content.type.match(/path/i) && {
      lessons: content.lessons ? content.lessons : [],
    }),
    description: content.description ? content.description : '',
  });
}

export function toggleDraggingContent() {
  return actions.toggleDraggingContent();
}

const requestPathContents = id => request.get(routes.PATH_VIEW(id));

export function fetchPathContents(id, type) {
  return (dispatch, getState) => {
    dispatch(actions.loadingContent(id, type));
    requestPathContents(id).then(response => {
      const props = pick(
        ['description', 'contents', 'enforcedOrder', 'urls'],
        response,
      );
      dispatch(update(id, type, props));
      dispatch(actions.loadingContentSuccess(id, type));
    });
  };
}

// eslint-disable-next-line
export function fetchContents(id, type) {
  if (type === TYPES.PATH) {
    return fetchPathContents(id, type);
  }
}
